import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import Navbar from "../../nav_bar/Navbar";
import Footer from "../../footer/Footer";
import { fetchHomonymById } from "./homonymService";
import "./HomonymDetailPage.css";

const HomonymDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      const res = await fetchHomonymById(id);
      if (res.status === 200 && res.data?.status) setData(res.data.data);
      setLoading(false);
    };
    load();
  }, [id]);

  if (loading) return (<><Navbar /><div className="hd-page"><p className="hd-loading">Loading...</p></div><Footer /></>);
  if (!data) return (<><Navbar /><div className="hd-page"><p className="hd-loading">Homonym not found.</p><button className="hd-back" onClick={() => navigate("/study/homonyms")}>← Back</button></div><Footer /></>);

  return (
    <>
      <Navbar />
      <div className="hd-page">
        <button className="hd-back" onClick={() => navigate("/study/homonyms")}>← Back to Homonyms</button>

        <div className="hd-hero">
          <h1 className="hd-word">{data.word}</h1>
          {(data.ipaPronunciation || data.phoneticPronunciation) && (
            <div className="hd-pronunciations">
              {data.ipaPronunciation && (
                <div className="hd-pron-item">
                  <span className="hd-pron-label">
                    IPA
                    <Link to="/study/ipa/lessons" className="hd-ipa-link" title="Learn IPA">ℹ</Link>
                  </span>
                  <span className="hd-pron-value">{data.ipaPronunciation}</span>
                </div>
              )}
              {data.phoneticPronunciation && (
                <div className="hd-pron-item">
                  <span className="hd-pron-label">How to say</span>
                  <span className="hd-pron-value phonetic">{data.phoneticPronunciation}</span>
                </div>
              )}
            </div>
          )}
        </div>

        <h2 className="hd-section-title">📖 Meanings</h2>
        <div className="hd-meanings">
          {data.meanings?.map((m, idx) => (
            <div key={idx} className="hd-meaning-card">
              <div className="hd-meaning-num">{idx + 1}</div>
              <div className="hd-meaning-body">
                {m.context && <span className="hd-meaning-context">{m.context}</span>}
                <p className="hd-meaning-text">{m.meaning}</p>
                {m.exampleSentence && <p className="hd-meaning-example">e.g. "{m.exampleSentence}"</p>}
              </div>
            </div>
          ))}
        </div>

        {data.youtubeLink && (
          <div className="hd-card">
            <h3 className="hd-card-title">🎬 Video Lesson</h3>
            <div className="hd-video-wrapper">
              <iframe
                src={data.youtubeLink.replace("watch?v=", "embed/").replace("youtu.be/", "youtube.com/embed/")}
                title={data.word} allowFullScreen frameBorder="0"
              />
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default HomonymDetailPage;
